export default __webpack_public_path__ + "static/media/july2024-3.ce19cdc2.jpg";